declare interface String {
  toSearchString(): string;
}

String.prototype.toSearchString = function(): string {
  return this.replace(/\s/g, '').toLowerCase();
};
